import { useEffect, useRef } from 'react';
import { usePageContext } from 'context/hooks/usePageContext';
import { useTransactionContext } from 'context/hooks/useTransactionContext';
import { PAGE_SUB, PAGES } from 'context/pageContext';
import { recordProvider } from 'utils/updateTransaction';

const CARD_END_SUBS = [
  PAGE_SUB.ERROR,
  PAGE_SUB.TIMEOUT,
  PAGE_SUB.PAYING,
  PAGE_SUB.REFUNDED,
  PAGE_SUB.REFUND_IN_PROGRESS,
];

/**
 * Records the provider once each time a card attempt reaches an end screen,
 * whatever the outcome. Mounted once above the desktop and mobile card screens,
 * which are both rendered at the same time.
 */
const useRecordCardAttempt = () => {
  const { page, sub } = usePageContext();
  const { ceviantTransactionId, provider } = useTransactionContext();
  const paymentPageRef = useRef(page);
  const hasEndedRef = useRef(false);

  useEffect(() => {
    // the success screen is shared with the other payment methods
    if (page !== PAGES.AUTHENTICATING) {
      paymentPageRef.current = page;
    }

    const hasEnded =
      paymentPageRef.current === PAGES.CARD &&
      (page === PAGES.AUTHENTICATING
        ? sub === PAGE_SUB.SUCCESS
        : CARD_END_SUBS.includes(sub));

    // a failure during checkout setup has no transaction or provider to record
    if (hasEnded && !hasEndedRef.current && ceviantTransactionId && provider) {
      recordProvider({ ceviantTransactionId, provider });
    }

    hasEndedRef.current = hasEnded;
  }, [page, sub, ceviantTransactionId, provider]);
};

export default useRecordCardAttempt;
